import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=4ca956a0&scoped=true"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=4ca956a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca956a0",
  null
  
)

export default component.exports